import React from 'react';

const MusicNoteLikeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M11.25 3v8.682c0 .341-.235.643-.564.733-1.011.28-1.898.91-2.486 1.738A4.5 4.5 0 006 17.25a4.5 4.5 0 004.5 4.5 4.5 4.5 0 004.5-4.5V7.5h3V3h-6Z" />
  </svg>
);

export default MusicNoteLikeIcon;
